import React, { useState } from "react";
import '../styles/HptScreens.css';
import SignaturePad from './SignaturePad';
import imagenFondo from '../assets/logo_elecnor.jpg';

const PermisoEscalera = ({ datosPrevios, onSave, onCancel, readOnly = false, usuarioActual, isPdfMode = false }) => {
    
    const [formData, setFormData] = useState(datosPrevios || {
        fechaSolicitud: new Date().toISOString().split('T')[0],
        delegacion: '', ubicacion: '', responsable: '', ordenTrabajo: '',
        altura: '', trabajoRealizar: '', numeroSerie: '',
        checkId: false, checkZona: false, checkPeldaños: false, checkZapatas: false,
        clasificacion: [],
        justificacion: [],
        firmaSolRetirada: null, firmaAutRetirada: null, firmaUsuEscalera: null,
        firmaSolDevolucion: null, firmaRecDevolucion: null, medioAutorizacion: ''
    });

    // Para identificar caja de firma
    const [firmaActiva, setFirmaActiva] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        // Lógica para los arrays (Clasificación y Justificación)
        if (name === 'justificacion' || name === 'clasificacion') {
            let nuevoArray = [...formData[name]];
            if (checked) {
                nuevoArray.push(value);
            } else {
                nuevoArray = nuevoArray.filter(item => item !== value);
            }
            setFormData({ ...formData, [name]: nuevoArray });
            return;
        }

        // Lógica normal para campos de texto y checkboxes únicos
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    // Funcion que recibe los datos del pad y los une con los datos del usuario
    const handleGuardarFirma = (base64) => {
        const fechaHora = new Date().toLocaleString('es-ES');
        const nombreCompleto = usuarioActual ? usuarioActual : 'Usuario Desconocido';

        setFormData({
            ...formData,
            [firmaActiva]: {
                base64: base64,
                nombre: nombreCompleto,
                fechaHora: fechaHora
            }
        });
        setFirmaActiva(null);
    };

    // Funcion para pintar cuadros de firmas.

    const renderCajaFirma = (label, fieldKey) => {
        const firma = formData[fieldKey];
        return (
            <div className="pe-sign-line" style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingBottom: '10px' }}>
                <span style={{ fontWeight: 'bold' }}>{label}:</span>
                {firma ? (
                    <div style={{ backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}>
                        <img src={firma.base64} alt="Firma" style={{ height: '40px', display: 'block', marginBottom: '5px' }} />
                        <div style={{ fontSize: '10px', color: '#555' }}>
                            <strong>Firmado por:</strong> {firma.nombre}
                            <strong>Fecha:</strong> {firma.fechaHora}
                        </div>
                    </div>
                ) : (
                    !readOnly && (
                        <button type="button" className="btn-save" style={{ width: 'fit-content', padding: '4px 10px', fontSize: '11px', backgroundColor: '#003366' }} onClick={() => setFirmaActiva(fieldKey)}>
                            ✍️ Firmar
                        </button>
                    )
                )}
            </div>
        );
    };


    const contenidoFormulario = (
        <div className={`pe-container ${isPdfMode ? 'pe-pdf-mode' : 'pe-modal-content'}`}>
                
            {/* --- CABECERA --- */}
            <header className="pe-header">
                <div className="pe-title-box">
                    <h2 className="pe-main-title">PERMISO ESPECIAL: USO DE ESCALERAS MANUALES</h2>
                </div>
                <div className="pe-logo"><img src={imagenFondo} alt="Logo" style={{ maxHeight: '40pxS' }} /> </div>
                <div className="pe-code">FIT.ELN.GEN-08.040.03</div>
            </header>

            {/* --- 0. DATOS DE LA SOLICITUD --- */}
            <section className="pe-section">
                <h3 className="pe-section-title">0. DATOS DE LA SOLICITUD</h3>
                <div className="pe-dat_sol-2">
                    <div className="pe-input-group">
                        <label>FECHA SOLICITUD:</label>
                        <input type="date" name="fechaSolicitud" value={formData.fechaSolicitud} onChange={handleChange} className="pe-input" />
                    </div>
                    <div className="pe-input-group">
                        <label>Nº PERMISO / ORDEN DE TRABAJO:</label>
                        <input type="text" name="ordenTrabajo" value={formData.ordenTrabajo} onChange={handleChange} className="pe-input" />
                    </div>
                    <div className="pe-input-group">
                        <label>DELEGACIÓN - CP-CT / SUBCONTRATISTA:</label>
                        <input type="text" name="delegacion" value={formData.delegacion} onChange={handleChange} className="pe-input" />
                    </div>
                    <div className="pe-input-group">
                        <label>Nº OBRA / UBICACIÓN:</label>
                        <input type="text" name="ubicacion" value={formData.ubicacion} onChange={handleChange} className="pe-input" />
                    </div>
                    <div className="pe-input-group pe-col-span-2">
                        <label>RESPONSABLE TRABAJOS (ELECNOR / SUBCON.):</label>
                        <input type="text" name="responsable" value={formData.responsable} onChange={handleChange} className="pe-input" />
                    </div>
                </div>
                
            </section>

            {/* Alerta si la altura es > 6 */}
            <div className={`pe-alert ${formData.altura > 6 ? 'pe-alert-danger' : ''}`}>
                SI LA ALTURA SUPERA LOS 6M NO USAR ESCALERA, CONTACTAR LÍNEA DE MANDO.
            </div>

            {/* --- 1. PUNTO DE TRABAJO --- */}
            <section className="pe-section">
                <h3 className="pe-section-title">1. PUNTO DE TRABAJO</h3>
                <div className="pe-grid-2">
                    <div className="pe-input-group">
                        <label>ALTURA (m):</label>
                        <input type="number" step="0.1" name="altura" value={formData.altura} onChange={handleChange} className="pe-input" placeholder="Ej: 2.5" />
                    </div>
                    <div className="pe-input-group">
                        <label>TRABAJO A REALIZAR:</label>
                        <input type="text" name="trabajoRealizar" value={formData.trabajoRealizar} onChange={handleChange} className="pe-input" />
                    </div>
                </div>
            </section>

            {/* --- 2. CHECKLIST PRE-USO --- */}
            <section className="pe-section">
                <h3 className="pe-section-title">2. CHECKLIST PRE-USO</h3>
                <div className="pe-input-group pe-serie-group">
                    <label>NÚMERO DE SERIE DE LA ESCALERA:</label>
                    <input type="text" name="numeroSerie" value={formData.numeroSerie} onChange={handleChange} className="pe-input" />
                </div>
                <div className="pe-checklist-grid">
                    <label className="pe-check-label">
                        <input type="checkbox" name="checkId" checked={formData.checkId} onChange={handleChange} />
                        ¿Escalera con ID y revisión anual vigente?
                    </label>
                    <label className="pe-check-label">
                        <input type="checkbox" name="checkZona" checked={formData.checkZona} onChange={handleChange} />
                        ¿Zona balizada y señalizada?
                    </label>
                    <label className="pe-check-label">
                        <input type="checkbox" name="checkPeldaños" checked={formData.checkPeldaños} onChange={handleChange} />
                        ¿Largueros/peldaños en perfecto estado?
                    </label>
                    <label className="pe-check-label">
                        <input type="checkbox" name="checkZapatas" checked={formData.checkZapatas} onChange={handleChange} />
                        ¿Zapatas y dispositivos de apertura en perfecto estado?
                    </label>
                </div>
            </section>

            {/* --- 3. CLASIFICACIÓN Y JUSTIFICACIÓN --- */}
            <section className="pe-section">
                <h3 className="pe-section-title">3. CLASIFICACIÓN Y JUSTIFICACIÓN</h3>
                <div className="pe-grid-2">
                    
                    {/* Columna Izquierda: Clasificación*/}
                    <div className="pe-box-bordered">
                        <div className="pe-radio-list">
                            <label><input type="checkbox" name="clasificacion" value="< 3,5 m" checked={formData.clasificacion.includes('< 3,5 m')} onChange={handleChange} /> Trabajos &lt; 3,5 m</label>
                            <label><input type="checkbox" name="clasificacion" value="3,5 a 6 m" checked={formData.clasificacion.includes('3,5 a 6 m')} onChange={handleChange} /> Trabajos entre 3,5 y 6 m</label>
                            <label><input type="checkbox" name="clasificacion" value="Encofrado" checked={formData.clasificacion.includes('Encofrado')} onChange={handleChange} /> Encofrado / Ferrallado</label>
                            <label><input type="checkbox" name="clasificacion" value="Apoyos" checked={formData.clasificacion.includes('Apoyos')} onChange={handleChange} /> Apoyos con antiescalos</label>
                            <label><input type="checkbox" name="clasificacion" value="Interiores" checked={formData.clasificacion.includes('Interiores')} onChange={handleChange} /> Interiores 3.5 - 6 m</label>
                            <label><input type="checkbox" name="clasificacion" value="Cubiertas" checked={formData.clasificacion.includes('Cubiertas')} onChange={handleChange} /> Acceso a cubiertas (H &lt; 7m)</label>
                        </div>
                    

                    {/* Columna Derecha: Justificación */}
                        <h4 className="pe-box-subtitle">¿POR QUÉ NO PEMP/ANDAMIO?</h4>
                        <div className="pe-radio-list">
                            <label><input type="checkbox" name="justificacion" value="Inaccesible" checked={formData.justificacion.includes("Inaccesible")} onChange={handleChange} /> Ubicación inaccesible</label>
                            <label><input type="checkbox" name="justificacion" value="Superficie" checked={formData.justificacion.includes("Superficie")} onChange={handleChange} /> Superficie no apta</label>
                            <label><input type="checkbox" name="justificacion" value="Espacio" checked={formData.justificacion.includes("Espacio")} onChange={handleChange} /> Espacio insuficiente</label>
                        </div>
                    </div>
                </div>
            </section>

            {/* --- FIRMAS --- */}
                <div className="pe-signature-box">
                    <strong>RETIRADA (REVISADA Y BUEN ESTADO):</strong>
                    <div className='agr-sign-ret'>
                        {renderCajaFirma('Solicitante', 'firmaSolRetirada')}
                        {renderCajaFirma('Autoriza ELECNOR', 'firmaAutRetirada')}
                    </div>

                    <div className="pe-input-autho">
                        <label>*Medio de autorización:</label>
                        <input type="text" name="medioAutorizacion" value={formData.medioAutorizacion} onChange={handleChange} disabled={readOnly}/>
                    </div>
                    
                    {renderCajaFirma('Usuario(s) de escalera', 'firmaUsuEscalera')}
                    
                    
                </div>
                
                <div className="pe-signature-box">
                    <strong>DEVOLUCIÓN (REVISADA Y BUEN ESTADO):</strong>
                    <div className='agr-sign-ret'>
                        {renderCajaFirma('Solicitante', 'firmaSolDevolucion')}
                        {renderCajaFirma('Recibe ELECNOR', 'firmaRecDevolucion')}
                    </div>
                </div>

            <div className="pe-footer-note">
                <span>AUTORIZACIÓN EXPRESA Y POR ESCRITO A LA LÍNEA DE MANDO DE ELECNOR.</span>
                <div className='pe-footer-line'></div>
                Archivar formato original en almacen y adjuntar copia en cierre de OT o PT
            </div>

        
        {/* --- BOTONERA INFERIOR DEL MODAL --- */}
        {!isPdfMode && (
            <div className="pe-modal-actions">
                <button type="button" className="btn-close" onClick={onCancel}>
                    {readOnly ? '❌ Cerrar' : '❌ Cancelar'}
                </button>
                {!readOnly && (
                    <button type="button" className="btn-save" onClick={() => onSave(formData)}>
                        💾 Guardar Anexo
                    </button>
                )}
            </div>
        )}

        {/* MODAL DEL PAD DE FIRMAS */}
            {firmaActiva && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 100000 }}>
                    <SignaturePad onSave={handleGuardarFirma} onCancel={() => setFirmaActiva(null)} />
                </div>
        )}
        </div>
    );

    if (isPdfMode) {
        return contenidoFormulario;
    }

    return (
        <div className="pe-modal-overlay">
            {contenidoFormulario}
            
        </div>
    );
};

export default PermisoEscalera;